module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6n5n1r-a4c0a03b336d7d2dcae7861ccabb7e25.svg";